import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';

import { translate } from 'services/i18nService';
import BroadcasterStore from 'stores/BroadcasterStore';


import styles from './ChatExpandButton.css';


function ChatExpandButton({ customClass }) {
  const {
    chatExpanded,
    showChatExpandButton,
    toggleExpandChat,
  } = BroadcasterStore;

  const handleChatExpand = useCallback(
    () => {
      toggleExpandChat();
    },
    [toggleExpandChat],
  );

  const buttonClasses = classNames({
    [styles.expand]: true,
    [styles.expandForceShow]: showChatExpandButton,
    [customClass]: Boolean(customClass),
  });

  return (
    <Tooltip title={translate('v2broadcast.adjust.chat.size')}>
      <div
        className={buttonClasses}
        id="BWRStep6"
        role="presentation"
        onClick={handleChatExpand}
      >
        {chatExpanded ? <ExpandLess /> : <ExpandMore />}
      </div>
    </Tooltip>
  );
}

ChatExpandButton.propTypes = { customClass: PropTypes.string };

ChatExpandButton.defaultProps = { customClass: '' };

export default observer(ChatExpandButton);
